import {i18n} from '@yourcoach/i18n';

export const getMonthlyPaymentPerUnitString = (): string =>
  i18n.t('shared:program.monthly_payment_per_unit_label', {
    unit: i18n.t('shared:program.duration_unit.month', {
      count: 1,
    }),
  });
